import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
  filters: {
    marginBottom: 0,
  },
  tableHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: 0,
  },
});
